<template>
  <div class="content-middle">
    <div class="cont-con clearfix">
      <div class="cont-left hidden-xs">
        <div class="contl-header">
          蓝牙超高频小精灵
          <button class="menu-button" id="open-button">Open Menu</button>
        </div>
        <div class="menu-wrap">
          <nav class="menu">
            <div class="icon-list">
              <router-link
                :to="{path: list.url, query: {index: index}}"
                :class="{'current': currentIndex == index}"
                v-for="(list, index) in lists"
                v-bind:key="index"
              >{{list.text}}</router-link>
            </div>
          </nav>
          <button class="close-button" id="close-button">Close Menu</button>
        </div>
      </div>
      <div class="cont-right">
        <div class="contr-header clearfix">
          <h4>{{buname}}</h4>
          <div class="contr-nav">
            <router-link to="/">首页</router-link>&gt;
            <router-link :to="{path:'/BU',query: {index: 0}}">蓝牙超高频小精灵</router-link>
            &gt; {{buname}}
          </div>
        </div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
     this.buname = this.$route.meta.title;
    this.currentIndex = this.$route.query.index;
  },
  data() {
    return {
      currentIndex: 0,
      buname: "BU01",
      lists: [
        { text: "BU01", url: "/BU/01" },
        { text: "BU01KB", url: "/BU/01KB" },
        { text: "BU01PB", url: "/BU/01PB" },
       
      ]
    };
  },
  methods: {},
  watch: {
    $route(to, from) {
      if (to != undefined) {
        this.currentIndex = to.query.index;
        this.buname = to.meta.title;
      }
    }
  },
  components: {}
};
</script>

<style lang="stylus" scoped rel="stylesheet/stylus"></style>



// WEBPACK FOOTER //
// src/components/BU/BUindex.vue